import { mountAuthCooldown } from './auth-cooldown';

export function mountAuth(root = document) {
	mountAuthCooldown(root);
	root.querySelectorAll('.solufy-auth-page-wrapper .es-button[data-variant="solid"]').forEach(button => {
		const label = button.textContent.trim();
		const updateLoading = () => {
			if (button.getAttribute('aria-busy') === 'true') {
				button.setAttribute('aria-label', `${label}, please wait`);
			} else {
				button.removeAttribute('aria-label');
			}
		};
		new MutationObserver(updateLoading).observe(button, { attributes: true, attributeFilter: ['aria-busy'] });
	});
	root.querySelectorAll('.solufy-auth-page-wrapper .toggle-password').forEach(toggle => {
		const input = root.querySelector(toggle.getAttribute('toggle'));
		if (!input) return;
		const updateLabel = () => {
			const visible = input.type === 'text';
			toggle.setAttribute('aria-label', visible ? 'Hide password' : 'Show password');
			toggle.setAttribute('aria-pressed', String(visible));
		};
		toggle.setAttribute('role', 'button');
		toggle.setAttribute('tabindex', '0');
		toggle.setAttribute('aria-controls', input.id);
		toggle.addEventListener('click', () => queueMicrotask(updateLabel));
		toggle.addEventListener('keydown', event => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				toggle.dispatchEvent(new MouseEvent('click', { bubbles: true }));
			}
		});
		updateLabel();
	});
}
